// extracted by mini-css-extract-plugin
module.exports = {"card":"HighlightCard_card___2ijD"};